import { IAddress } from '@src/models/interfaces/address.interface';

class TimeTrackerUtils {
  /**
   * Formats address as: street → number → floor/office (optional) → commune → city → region → zip.
   * Omits empty segments; avoids duplicating commune when it equals city.
   */
  static getAddressString(address: IAddress | null | undefined): string {
    if (!address) return '';

    const parts: string[] = [];

    const push = (value: string | null | undefined) => {
      const t = value?.trim();
      if (t) parts.push(t);
    };

    push(address.address);
    push(address.floorOffice);

    const commune = address.commune?.trim();
    const city = address.city?.trim();

    if (commune) {
      parts.push(commune);
    }
    if (city && city.toLowerCase() !== commune?.toLowerCase()) {
      parts.push(city);
    }

    push(address.region);
    push(address.zip);

    return parts.join(', ');
  }
}

export default TimeTrackerUtils;
